import { render, staticRenderFns } from "./SearchResultContainer.vue?vue&type=template&id=006c14b2&scoped=true"
import script from "./SearchResultContainer.vue?vue&type=script&lang=js"
export * from "./SearchResultContainer.vue?vue&type=script&lang=js"
import style0 from "./SearchResultContainer.vue?vue&type=style&index=0&id=006c14b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c14b2",
  null
  
)

export default component.exports